import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between px-2 py-3 mb-3" }
const _hoisted_2 = { class: "container flex flex-wrap items-center justify-between mx-auto" }
const _hoisted_3 = { class: "w-full flex justify-between lg:w-auto lg:static" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row list-none ml-auto" }
const _hoisted_5 = { class: "ml-2" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = {
  class: "cursor-pointer flex items-center text-xl hover:opacity-50 md:px-3 px-5 pb-2 pt-2.5 text-blue-500",
  href: "https://www.facebook.com/FlavoursBroodjes"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa = _resolveComponent("fa")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "text-2xl font-extrabold whitespace-nowrap uppercase text-pink-800 cursor-pointer mr-4 py-2"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Flavours ")
          ])),
          _: 1,
          __: [1]
        }),
        _createElementVNode("button", {
          class: "cursor-pointer text-xl border border-solid rounded block lg:hidden px-3 py-1",
          type: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
        }, [
          _createVNode(_component_fa, { icon: "bars" })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{ hidden: !_ctx.showMenu, flex: _ctx.showMenu }, "lg:flex lg:flex-grow items-center"])
      }, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navItems, (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              key: index
            }, [
              _createVNode(_component_router_link, {
                to: item.path,
                class: "cursor-pointer flex items-center text-md uppercase font-bold text-gray-800 hover:opacity-75 px-3 py-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_6, [
            _createElementVNode("a", _hoisted_7, [
              _createVNode(_component_fa, { icon: ['fab', 'facebook'] })
            ])
          ])
        ])
      ], 2)
    ])
  ]))
}